import { __extends } from "tslib";
import { ListStreamsInput, ListStreamsOutput } from "../models/index";
import { deserializeAws_json1_1ListStreamsCommand, serializeAws_json1_1ListStreamsCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var ListStreamsCommand = /** @class */ (function (_super) {
    __extends(ListStreamsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListStreamsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    ListStreamsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: ListStreamsInput.filterSensitiveLog,
            outputFilterSensitiveLog: ListStreamsOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListStreamsCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1ListStreamsCommand(input, context);
    };
    ListStreamsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1ListStreamsCommand(output, context);
    };
    return ListStreamsCommand;
}($Command));
export { ListStreamsCommand };
//# sourceMappingURL=ListStreamsCommand.js.map